import axios from "axios";
import { apiBase, blankUser } from "@/constants";
import store from "@/store";
import router from "@/router";
import { getSelf } from "@/api/users";
import { prepareSalesTracking } from '@/salesTracking';

axios.defaults.baseURL = apiBase
axios.defaults.responseType = "json"
axios.defaults.headers.common = {
    "Authorization": "Bearer " + localStorage.getItem('access_token'),
    "Content-Type": "application/json",
    "Accept": "application/json"
}
prepareSalesTracking();
axios.interceptors.response.use(config => config, error => {
    const response = error.response;
    if (!response) return Promise.reject(error);
    const status = response.status;
    if (status == 401) {
        clearAccessToken();
        const route = router.currentRoute.value;
        if ("auth" in route.meta) {
            router.push({ name: 'login' }).then().catch()
            return Promise.reject(error);
        }
    }
    const data = response.data && typeof response.data === 'object' ? response.data : {};
    store.state.error.message = data.message ?? null;
    store.state.error.errors = data.errors ?? {};
    return Promise.reject(data);
});

export function setAccessToken(token: string): void {
    localStorage.setItem('access_token', token)
    axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
}

export function clearAccessToken() {
    localStorage.removeItem('access_token');
    axios.defaults.headers.common["Authorization"] = 'Bearer';
    clearUser();
}

export async function getUser() {
    if (store.state.user.id !== -1) return store.state.user;
    const token = localStorage.getItem('access_token');
    if (token !== null) {
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
        try {
            const { data } = await getSelf();
            store.commit('setUser', data);
            return data;
        } catch (e) {
            console.error('Failed to retrieve user', e)
        }
    }
    return blankUser;
}

export const clearUser = () => store.state.user = blankUser;

export * as auth from "./auth";
export * as changelog from "./changelog";
export * as guestCheckout from "./guestCheckout";
export * as config from "./config";
export * as guides from "./guides";
export * as manage from "./manage";
export * as messages from "./messages";
export * as payment from "./payment";
export * as stats from "./stats";
export * as scripts from "./scripts";
export * as tickets from "./tickets";
export * as supportAssistant from "./supportAssistant";
export * as users from "./users";
export * as keys from "./keys";
export * as reseller from "./reseller";
export * as banAppeals from "./banAppeals";
export * as mediaApplications from "./mediaApplications";
export * as giveaways from "./giveaways";
export * as gifts from "./gifts";
export * as playerList from "./playerList";
export * from "./playerList";
export * from "./types";
